import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { Stack } from "components/layout/reusableLayouts";
import { AcquiringPaymentStatus } from "enums/AcquiringPaymentStatus";
import { PublicPaymentLink } from "hooks/usePayLinkSession";
import PayLinkSuccess from "components/payLink/PayLinkSuccess";

interface PayLinkOutcomeProps {
  status: string | null;
  paymentLink?: PublicPaymentLink;
  companyName?: string;
}

/* An acquirer redirect can represent failure; show a receipt only after confirmed success. */
const PayLinkOutcome: React.FC<PayLinkOutcomeProps> = ({
  status,
  paymentLink,
  companyName,
}) => {
  const { t } = useTranslation();

  if (status === AcquiringPaymentStatus.SUCCEEDED) {
    return (
      <PayLinkSuccess paymentLink={paymentLink} companyName={companyName} />
    );
  }

  const message =
    status === AcquiringPaymentStatus.FAILED ||
    status === AcquiringPaymentStatus.CANCELED
      ? "payLink.OutcomeFailed"
      : "payLink.OutcomePending";

  return (
    <Stack sx={{ gap: "var(--space-3)", textAlign: "center" }}>
      <Typography variant="h5">
        {status === AcquiringPaymentStatus.FAILED ||
        status === AcquiringPaymentStatus.CANCELED
          ? t("payLink.OutcomeFailedTitle")
          : t("payLink.OutcomePendingTitle")}
      </Typography>
      <Typography variant="body1">{t(message)}</Typography>
    </Stack>
  );
};

export default PayLinkOutcome;
